import { ERcptMethod, ETxnType } from '../bill-management/entryRecords';

export interface IOrderStatsParams {
  /** 周期类型 DAY：天 WEEK：周 MONTH：月 YEAR：年 */
  cycle: string;
  /** 开始日期 */
  beginDate: string;
  /** 结束日期 */
  endDate: string;
  page: number;
  size: number;
  /** 排序字段 */
  sortingFields?: string;
}

export interface IOrderStatsItem {
  /** 周期类型 DAY：天 WEEK：周 MONTH：月 YEAR：年 */
  cycle: string;
  /** 开始日期 */
  beginTime: string;
  /** 结束日期 */
  endTime: string;
  /** 收款金额 */
  rcptAmt: number;
  /** 收款手续费 */
  rcptFee: number;
  /** 实际到账金额 */
  actualAmt: number;
  /** 收款笔数 */
  rcptCount: number;
  /** 退款金额 */
  refundAmt: number;
  /** 退款笔数 */
  refundCount: number;
  /** 结算金额 */
  settleAmt: number;
  /** 结算笔数 */
  settleCount: number;
  /** 分账金额 */
  distAmt: number;
  /** 分账手续费 */
  distFee: number;
  /** 分账笔数 */
  distCount: number;
  /** 自留金额 */
  stayAmt: number;
}

export enum EOrderStatsCycle {
  /** 天 */
  DAY = 'DAY',
  /** 周 */
  WEEK = 'WEEK',
  /** 月 */
  MONTH = 'MONTH',
  /** 年 */
  YEAR = 'YEAR',
}

export const orderStatsCycleConfig = {
  [EOrderStatsCycle.DAY]: '天',
  [EOrderStatsCycle.WEEK]: '周',
  [EOrderStatsCycle.MONTH]: '月',
  [EOrderStatsCycle.YEAR]: '年',
};

export interface IOrderStatsViaSceneParams {
  /** 周期类型 DAY：天 WEEK：周 MONTH：月 YEAR：年 */
  cycle: string;
  /** 开始日期 */
  beginDate: string;
  /** 结束日期 */
  endDate: string;
  page: number;
  size: number;
  /** 排序字段 */
  sortingFields?: string;
  /** 统计场景 STORE：门店 STAFF：员工 TERMINAL：终端 */
  scene?: EOrderStatsScene;
}

export interface IOrderStatsViaSceneItem {
  /** 周期类型 DAY：天 WEEK：周 MONTH：月 YEAR：年 */
  cycle: string;
  /** 开始日期 */
  beginTime: string;
  /** 结束日期 */
  endTime: string;
  /** 收款方式 QR_CODE：二维码 PUBLIC_WITHDRAWAL：公域提现 OPENAPI：开放 API 收款 POS_TERMINAL：POS 终端 ACCOUNT_BOOK：记账簿收款 ,可用值:QR_CODE,PUBLIC_WITHDRAWAL,OPENAPI,POS_TERMINAL,ACCOUNT_BOOK */
  rcptMethod: ERcptMethod;
  /** 收款来源 */
  rcptSource: string;
  /** 门店名称 */
  storeName: string;
  /** 员工姓名 */
  staffName: string;

  /** 收款金额 */
  rcptAmt: number;
  /** 收款手续费 */
  rcptFee: number;
  /** 实际到账金额 */
  actualAmt: number;
  /** 收款笔数 */
  rcptCount: number;

  /** 退款金额 */
  refundAmt: number;
  /** 退款笔数 */
  refundCount: number;
  /** 结算金额 */
}

export enum EOrderStatsScene {
  /** 门店 */
  STORE = 'STORE',
  /** 员工  */
  STAFF = 'STAFF',
  /** 终端 */
  TERMINAL = 'TERMINAL',
}

export const orderStatsSceneConfig = {
  [EOrderStatsScene.STORE]: '门店',
  [EOrderStatsScene.STAFF]: '员工',
  [EOrderStatsScene.TERMINAL]: '终端',
};

export interface IOrderTransactionRecodingParams {
  /** 开始日期 */
  startDate: string;
  /** 结束日期 */
  endDate: string;
  page: number;
  size: number;
  /** 排序字段 */
  sortingFields?: string;
  /** 是否是门店订单。默认：false */
  fromStore?: boolean;
}

export interface IIOrderTransactionRecodingContext {
  /** 数据 */
  data: IOrderTransactionRecodingItem[];
  /** 总量 */
  total: number;
  /** 期初总余额 */
  initBalance: number;
  /** 期末总余额 */
  finalBalance: number;
  /** 收款金额 */
  rcptAmt: number;
  /** 退款金额 */
  refundAmt: number;
  /** 分账金额 */
  distAmt: number;
  /** 分账冲退金额 */
  distReversedAmt: number;
  /** 自留金额 */
  selfKeepAmt: number;
}

export interface IOrderTransactionRecodingItem {
  /** 商户订单号 */
  orderNo: string;
  /** 支付订单号 */
  tpOrderNo: string;
  /** 交易类别 RECEIPT：收款 REFUND：退款 DISTRIBUTION：分账 DISTRIBUTION_SELF_KEEP：分账自留 DISTRIBUTION_REVERSED：分账冲退  */
  txnCategory: ETxnCategory;
  /** 交易方式 WECHAT：微信支付 ALIPAY：支付宝 UNIONPAY：银联云闪付 POS：刷卡 WITHDRAWAL_POSTED：提现入账 BANK_TRANSFER：银行转账 DISTRIBUTION：分账  */
  txnType: ETxnType;
  /** 收款方式 QR_CODE：二维码 PUBLIC_WITHDRAWAL：公域提现 OPENAPI：开放 API 收款 POS_TERMINAL：POS 终端收款 ACCOUNT_BOOK：记账簿支付  */
  rcptMethod: ERcptMethod;
  /** 交易金额 */
  txnAmt: number;
  /** 交易手续费 */
  txnFee: number;
  /** 实际到账金额 */
  actualAmt: number;
  /** 币种 */
  currency: string;
  /** 期初总余额 */
  initBalance: number;
  /** 期末总余额 */
  finalBalance: number;
  /** 交易时间 */
  txnTime: string;
  /** 交易日期 */
  txnDate: string;
  /** 备注 */
  memo: string;
}

export enum ETxnCategory {
  /** 收单 */
  RECEIPT = 'RECEIPT',
  /** 退款 */
  REFUND = 'REFUND',
  /** 分账 */
  DISTRIBUTION = 'DISTRIBUTION',
  /** 分账自留 */
  // DISTRIBUTION_SELF_KEEP = 'DISTRIBUTION_SELF_KEEP',
  /** 分账异常退回 */
  // DISTRIBUTION_REVERSED = 'DISTRIBUTION_REVERSED',
  /** 待分账 */
  UNDISTRIBUTION = 'UNDISTRIBUTION',
  /** 待结算 */
  UNSETTLED = 'UNSETTLED',
  /** 已结算 */
  SETTLED = 'SETTLED',
  /** 分账冻结 */
  DISTRIBUTION_FROZEN = 'DISTRIBUTION_FROZEN',
  /** 分账收款 */
  DISTRIBUTION_RECEIVE = 'DISTRIBUTION_RECEIVE'
}

export const txnCategoryConfig = {
  [ETxnCategory.RECEIPT]: '订单收款',
  [ETxnCategory.REFUND]: '订单退款',
  [ETxnCategory.DISTRIBUTION]: '分账付款',
  // [ETxnCategory.DISTRIBUTION_SELF_KEEP]: '订单分账自留',
  // [ETxnCategory.DISTRIBUTION_REVERSED]: '分账异常退回',
  [ETxnCategory.UNDISTRIBUTION]: '分账异常退回',
  [ETxnCategory.UNSETTLED]: '待结算',
  [ETxnCategory.SETTLED]: '已结算',
  [ETxnCategory.DISTRIBUTION_FROZEN]: '分账冻结',
  [ETxnCategory.DISTRIBUTION_RECEIVE]: '分账收款',
};

export const currencyConfig = { CNY: '人民币' };

export interface ICompanyBusinessSummaryParams extends IOrderTransactionRecodingParams { }

export interface ICompanyBusinessSummary {
  /** 企业ID */
  companyId: number;
  /** 收款合计 */
  rcptAmt: number;
  /** 收款笔数 */
  rcptCount: number;
  /** 手续费合计 */
  rcptFee: number;
  /** 退款合计 */
  refundAmt: number;
  /** 退款笔数 */
  refundCount: number;
  /** 分账合计 */
  distAmt: number;
  /** 分账笔数 */
  distCount: number;
  /** 企业编码 */
  companyCode: string;
  /** 企业名称 */
  companyName: string;
  /** 代理商ID */
  agentId: number;
  /** 代理商编号 */
  agentCode: string;
  /** 代理商名称 */
  agentName: string;
  /** 代理商等级 */
  agentLevel: number;
}